/* global wp, jQuery */
/**
 * File customizer.js.
 *
 * Theme Customizer enhancements for a better user experience.
 *
 * Contains handlers to make Theme Customizer preview reload changes asynchronously.
 */

( function( $ ) {

	//$(".with-square").append('<div class="squares"><span class="s1"></span><span class="s2"></span><span class="s3"></span></div>');

	// if ($("body.woocommerce-cart .cart-empty").length) {
	// 	window.location = '/nos-formations/catalogue/';
	// }

	//var equipeCol = 0;
	var equipe = [];
	$(".equipe-item").each(function() {
		equipe.push($(this).attr("id"));

	// 	if ($(this).parents('.wp-block-columns').find('.wp-block-column').length > equipeCol) {
	// 		equipeCol = $(this).parents('.wp-block-columns').find('.wp-block-column').length;
	// 	}
	});

	// if (equipeCol > 4) {
		$(".equipe-item").parents('.wp-block-columns').addClass("equipe");
	//}


	$(".where a.info").on("click", function() {
		$(this).toggleClass("open");
	});

	$(".equipe-item").each(function() {
		var position = equipe.indexOf($(this).attr("id"));

		var next = 0;
		var previous = 0;
		
		if (position > 0) { previous = 1; }
		if ((equipe.length - 1) > position) { next = 1; }

		if (!next) {
			$(this).find(".next").hide();
		} 

		if (!previous) {
			$(this).find(".previous").hide();
		} 
	});

	$(".equipe-item").on("click", '.next', function() {

		var position = equipe.indexOf($(this).parents(".equipe-item").attr("id"));
		
		var next = 0;
		var current = equipe[position];
		
		if ((equipe.length - 1) > position) { next = 1; }

		if (next) {
			 var nextel = equipe[position+1];
			 if ($("#" + nextel).length) {
			 	$("#" + current).removeClass("open");
			 	$("#" + nextel).addClass("open");
			 }
		}
	});

	$(".equipe-item").on("click", '.previous', function() {

		var position = equipe.indexOf($(this).parents(".equipe-item").attr("id"));

		var previous = 0;
		var current = equipe[position];
		
		if (position > 0) { previous = 1; }
		
		if (previous) {
			 var prevel = equipe[position-1];
			 if ($("#" + prevel).length) {
			 	$("#" + current).removeClass("open");
			 	$("#" + prevel).addClass("open");
			 }
		}
	});

	$(".equipe-item > .photo").on("click", function() {
		$(".shade").addClass("open");
		$(this).parents('.equipe-item').addClass("open");
	});

	$(".shade").on("click", function() {
		$(".open").removeClass("open");
	});

	if (prenom) {
		$("#top-menu li.mon-compte a").html(prenom);
	}

	$("#reg_optin").on("change", function() {
		$("#mailchimp_woocommerce_newsletter").prop("checked", $("#reg_optin").prop("checked"));
	});

	if ($("#presences").length) {
		$("#presences li").on("click", function() {

			var status = 0;
			var column = $(this).attr("data-column");
			var idPresence = $(this).attr("data-idpresence");

			if ($(this).hasClass("state0")) {
				$(this).removeClass("state0");
				$(this).addClass("state1");
				$(this).attr("data-presence", 1);
				status = 1;
			} else {
				$(this).removeClass("state1");
				$(this).addClass("state0");
				$(this).attr("data-presence", 0);
			}

			
			$.ajax({
				url: Formatio.ajax + "?action=formatio_presence&status=" + status + "&idPresence=" + idPresence + "&column=" + column
			}).done(function() {
			
			});


		});
	}


	if ($(".cycle-slideshow").length) {
		$(".cycle-slideshow").on( 'cycle-before', function( event, optionHash, outgoingSlideEl, incomingSlideEl, forwardFlag ) {
			var img = incomingSlideEl.getAttribute("data-image");
			var link = incomingSlideEl.getAttribute("data-link");
			if (img) {
				$("div.hero").css("background-image", "url(" + img + ")");
				$("div.hero").unbind("click");
				if (link) {
					$("div.hero").on("click", function() {
						window.location = link;
					});
				}
			}
		});


		var link = $(".cycle-slideshow .slide:first-child").attr("data-link");
		if (link) {
			$("div.hero").on("click", function() {
				window.location = link;
			});
		}
	}
	
}( jQuery ) );



jQuery(window).ready(function () {

	if (jQuery("#billing_address_2_field label").length) {
		address2ToStreet();
	}

	setTimeout(function() { address2ToStreet(); }, 3000);

	if (jQuery("form.checkout.woocommerce-checkout.hasFree1.hasCard1").length ) {
		jQuery("#gform_wrapper_4").addClass("close");
	}
		


	jQuery(document).on('gform_confirmation_loaded', function(event, formId) {
		console.log(formId);
		
		if (jQuery("body.woocommerce-checkout").length) {

			if (formId == 8 && jQuery("form.checkout.woocommerce-checkout.hasFree1").length ) {
				if (jQuery("form.checkout.woocommerce-checkout.hasCard1").length) {
					jQuery("#gform_wrapper_4").removeClass("close");
					jQuery("#gform_wrapper_8").addClass("close");
				} else {
					jQuery("form.checkout.woocommerce-checkout").show();
				}
			}

			if (formId == 4) {
				jQuery("#gform_wrapper_4").addClass("close");
				jQuery("form.checkout.woocommerce-checkout").show();
			}

		}
	});




});

function address2ToStreet() {
	if (jQuery("#billing_address_2_field label .required").length) { return; }
	
	jQuery("#billing_address_2_field label .optional").remove();
	
	var a2 = jQuery("#billing_address_2_field label").html();
	
	jQuery("#billing_address_2_field label").html(a2+"<abbr class=\"required\" title=\"obligatoire\">*</abbr>");
	jQuery("#billing_address_2_field").addClass('validate-required');
}